import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { useAbility } from '../../../modules/users/AbilityContext';
import {
  getAnnouncementKey,
  getCurrentAnnouncementKey,
  getFindAnnouncementsKey,
} from './announcements.keys';
import {
  findAnnouncements,
  getAnnouncementById,
  getCurrentAnnouncement,
} from './announcements.repository';
import { AnnouncementOutput } from './announcements.types';

export const useCurrentAnnouncement = (
  options?: UseDataQueryOptions<AnnouncementOutput | null>,
) => {
  const ability = useAbility();

  return useDataQuery<AnnouncementOutput | null>(
    {
      queryKey: getCurrentAnnouncementKey(),
      queryFn: async () => {
        const response = await getCurrentAnnouncement();

        if (!response.ok) {
          throw response.originalError;
        }

        return response.data ?? null;
      },
    },
    { enabled: ability.can('read', 'announcements'), retry: false, ...options },
  );
};

export const useFindAnnouncements = (options?: UseDataQueryOptions<AnnouncementOutput[]>) =>
  useDataQuery<AnnouncementOutput[]>(
    {
      queryKey: getFindAnnouncementsKey(),
      queryFn: async () => {
        const response = await findAnnouncements();

        if (!response.ok || !response.data) {
          throw response.originalError;
        }

        return response.data;
      },
    },
    options,
  );

export const useAnnouncement = (
  announcementId: string,
  options?: UseDataQueryOptions<AnnouncementOutput>,
) =>
  useDataQuery<AnnouncementOutput>(
    {
      queryKey: getAnnouncementKey(announcementId),
      queryFn: async () => {
        const response = await getAnnouncementById(announcementId);

        if (!response.ok || !response.data) {
          throw response.originalError;
        }

        return response.data;
      },
    },
    options,
  );
